export default {
    regStart: "Start",
    participants: "Teilnehmende",
    caregivers: "Betreuende",
    persons: "Personen",
    registrationDetails: "Anmeldungsdetails",
    details: "Details",
    participantsDetails: "Teilnahmedetails",
    personDetails: "Personendetails",
    payment: "Zahlung",
    contactPerson: "Ansprechperson",
    regSummary: "Zusammenfassung"
}
